export default __webpack_public_path__ + "static/ku_wzor_czerwona-573d2ec3a064d59251be3a151a2d1e4a.jpg";